import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Send({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Send</title>
      <path
        d="M4 4L4.33541 3.32918C4.07343 3.19819 3.75918 3.23169 3.5307 3.41497C3.30223 3.59824 3.20136 3.89775 3.27239 4.1819L4 4ZM20 12L20.3354 12.6708C20.5895 12.5438 20.75 12.2841 20.75 12C20.75 11.7159 20.5895 11.4562 20.3354 11.3292L20 12ZM4 20L3.27239 19.8181C3.20136 20.1023 3.30223 20.4018 3.5307 20.585C3.75918 20.7683 4.07343 20.8018 4.33541 20.6708L4 20ZM3.66459 4.67082L19.6646 12.6708L20.3354 11.3292L4.33541 3.32918L3.66459 4.67082ZM19.6646 11.3292L3.66459 19.3292L4.33541 20.6708L20.3354 12.6708L19.6646 11.3292ZM4.72761 20.1819L6.72761 12.1819L5.27239 11.8181L3.27239 19.8181L4.72761 20.1819ZM6.72761 11.8181L4.72761 3.8181L3.27239 4.1819L5.27239 12.1819L6.72761 11.8181ZM6 12.75H20V11.25H6V12.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
